var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuySellCarouselItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 9,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 69 9)",
    fill: "#F2E9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 28,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(90 168 28)",
    fill: "#EB3366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_67526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.606 39.0703H56.0349C51.9716 39.0703 48.6777 42.3643 48.6777 46.4275V90.5703",
    stroke: "url(#paint0_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.321 46.4297V90.5725C144.321 94.6359 141.027 97.9297 136.964 97.9297H63.3926",
    stroke: "url(#paint1_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5 81.375C103.611 81.375 109.375 75.6107 109.375 68.5C109.375 61.3893 103.611 55.625 96.5 55.625C89.3893 55.625 83.625 61.3893 83.625 68.5C83.625 75.6107 89.3893 81.375 96.5 81.375Z",
    stroke: "url(#paint2_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4155 70.3387C64.3997 70.3387 63.5762 69.5152 63.5762 68.4994C63.5762 67.4836 64.3997 66.6602 65.4155 66.6602",
    stroke: "url(#paint3_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.416 70.3387C66.4318 70.3387 67.2553 69.5152 67.2553 68.4994C67.2553 67.4836 66.4318 66.6602 65.416 66.6602",
    stroke: "url(#paint4_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.583 70.3387C126.567 70.3387 125.744 69.5152 125.744 68.4994C125.744 67.4836 126.567 66.6602 127.583 66.6602",
    stroke: "url(#paint5_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.584 70.3387C128.6 70.3387 129.423 69.5152 129.423 68.4994C129.423 67.4836 128.6 66.6602 127.584 66.6602",
    stroke: "url(#paint6_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.57 28.0352L129.606 39.0709L118.57 50.1066",
    stroke: "url(#paint7_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4283 86.8906L63.3926 97.9263L74.4283 108.962",
    stroke: "url(#paint8_linear_332_67526)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.5,
    cy: 115.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 104.5 115.5)",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_332_67526",
    x1: 39.9999,
    y1: 95.4628,
    x2: 145.351,
    y2: 85.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_332_67526",
    x1: 54.7147,
    y1: 102.822,
    x2: 160.065,
    y2: 93.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_332_67526",
    x1: 80.8639,
    y1: 83.8213,
    x2: 114.545,
    y2: 81.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_332_67526",
    x1: 63.3789,
    y1: 70.6882,
    x2: 65.7907,
    y2: 70.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_332_67526",
    x1: 65.2188,
    y1: 70.6882,
    x2: 67.6305,
    y2: 70.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_332_67526",
    x1: 125.547,
    y1: 70.6882,
    x2: 127.959,
    y2: 70.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_332_67526",
    x1: 127.387,
    y1: 70.6882,
    x2: 129.799,
    y2: 70.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_332_67526",
    x1: 117.387,
    y1: 52.2034,
    x2: 131.857,
    y2: 51.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_332_67526",
    x1: 62.2092,
    y1: 111.059,
    x2: 76.6797,
    y2: 110.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_67526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white",
    transform: "translate(45 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySellCarouselItem);
export default __webpack_public_path__ + "static/media/buy_sell_carousel_item.dd064136c965b7eef6548b3efb97ace7.svg";
export { ForwardRef as ReactComponent };